// extracted by mini-css-extract-plugin
module.exports = {"firstKv":"firstKv_firstKv__GI_Tf"};